import apiFetch from '../apiFetch'

export default function (idVerraco) {
  return apiFetch({endPoint: `Analisis/cambiarAnalisisVigilado?idVerraco=${idVerraco}`, method: 'GET', body: null})
}
